import React, { useState, useEffect } from 'react';
import {
  Tabs,
  Form,
  DatePicker,
  Select,
  Table,
  Checkbox,
  // message,
  Col,
  Row,
  Input
} from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
// , EyeOutlined
import moment from 'moment';
import CustomModal from '@/common/CustomModal';
// import CustomButton from '@/common/CustomButton';
import FormItem from '@/common/FormItem';
import './AddDelegationModal.css';
// import { useDispatch } from 'react-redux';
import LocalStorage from 'utilities/localStorage';
// import { editDelegationId } from '../../../redux/slice';
// import { editDelegationId } from '@/pages/settings/redux/slice';

const { TabPane } = Tabs;
const { Option } = Select;

const ViewDelegationModal = ({
  isViewModalVisible = false,
  onCancel,
  setIsViewModalOpen,
  // onDelegate,
  // handleGetActivity,
  editDelegationDetails,
  allApprovers
  // allPendingEnvelopes
  // delegationData = null
}) => {
  const [activeTab, setActiveTab] = useState('future');
  const [futureForm] = Form.useForm();
  const [stockForm] = Form.useForm();
  // const [loading, setLoading] = useState(false);
  const [selectedEnvelopes, setSelectedEnvelopes] = useState([]);
  const isReadOnly = true;
  // const dispatch = useDispatch();
  const user = LocalStorage.getItem('gnfa_user');
  const approvers = allApprovers;

  // console.log('editDelegationDetails', editDelegationDetails);
  // const envelopes = allPendingEnvelopes || [];
  // const envelopes = editDelegationDetails || [];
  const envelopes =
    editDelegationDetails?.envelope_approvers?.map((e) => ({
      id: e.envelope?.id,
      title: e.envelope?.title
    })) || [];
  // console.log('envelopes_12334', allPendingEnvelopes);
  // 🔁 Format the incoming payload to match the form
  const formatDelegationData = (data) => {
    if (!data) return null;
    return {
      id: data.id,
      type: data.type,
      delegation_start: data.fut_del_start
        ? moment(data.fut_del_start).format('YYYY-MM-DD')
        : undefined,
      delegation_end: data.fut_del_end
        ? moment(data.fut_del_end).format('YYYY-MM-DD')
        : undefined,
      // delegator_id: data.delegator_id,
      delegator_id: data.delegator
        ? `${data.delegator.display_name} - (${data.delegator.email})`
        : '',
      // delegate_id: data.delegate_id,
      delegate_id: data.delegate
        ? `${data.delegate.display_name} - (${data.delegate.email})`
        : '',
      // env_ids: data.envelope_approvers?.map((e) => e.envelope_id) || []
      env_ids:
        data.envelope_approvers?.map((e) => ({
          id: e.envelope_id,
          // id: Number(e.envelope?.id),
          title: e.envelope?.title
        })) || []
    };
  };
  // console.log('formatDelegationData', formatDelegationData);
  console.log('useEffect_editDelegationDetails', editDelegationDetails);
  console.log('useEffect_isViewModalVisible', isViewModalVisible);
  useEffect(() => {
    if (editDelegationDetails && isViewModalVisible) {
      const formatted = formatDelegationData(editDelegationDetails);
      setActiveTab(formatted.type || 'future');
      console.log('formatted', formatted);
      if (formatted.type === 'future') {
        futureForm.setFieldsValue({
          delegation_start: formatted.delegation_start,
          delegation_end: formatted.delegation_end,
          delegator_id: formatted.delegator_id,
          delegate_id: formatted.delegate_id
        });
      } else if (formatted.type === 'stock') {
        stockForm.setFieldsValue({
          delegator_id: formatted.delegator_id,
          delegate_id: formatted.delegate_id
        });

        setSelectedEnvelopes(formatted.env_ids);
      }
    }
  }, [editDelegationDetails, isViewModalVisible, futureForm, stockForm]);

  const handleTabChange = (key) => setActiveTab(key);

  const handleModalClose = () => {
    futureForm.resetFields();
    stockForm.resetFields();
    setSelectedEnvelopes([]);
    setIsViewModalOpen?.(false);
    onCancel?.();
  };

  const envelopeColumns = [
    {
      title: '',
      dataIndex: 'id',
      width: 50,
      render: (id) => (
        <Checkbox
          checked={selectedEnvelopes.includes(id)}
          disabled={isReadOnly}
          onChange={(e) => {
            if (isReadOnly) return;
            const updated = e.target.checked
              ? [...selectedEnvelopes, id]
              : selectedEnvelopes.filter((item) => item !== id);
            setSelectedEnvelopes(updated);
            stockForm.setFieldsValue({ env_ids: updated });
          }}
        />
      )
    },
    {
      title: 'Envelope ID',
      dataIndex: 'id',
      render: (id) => `#${id}`
    },
    {
      title: 'Name',
      // dataIndex: 'name'
      dataIndex: 'title'
    }
  ];

  // const isAllSelected = selectedEnvelopes.length === envelopes.length;
  // const isIndeterminate =
  //   selectedEnvelopes.length > 0 && selectedEnvelopes.length < envelopes.length;

  const renderFutureTab = () => (
    <Form form={futureForm} layout="vertical">
      <Row gutter={16}>
        <Col span={12}>
          <FormItem
            label="Start Date"
            name="delegation_start"
            rules={[{ required: true, message: 'Please select start date' }]}
          >
            {isReadOnly ? (
              <Input
                readOnly
                value={
                  futureForm.getFieldValue('delegation_start')
                    ? moment(
                        futureForm.getFieldValue('delegation_start')
                      ).format('YYYY-MM-DD')
                    : ''
                }
              />
            ) : (
              ''
            )}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem
            label="End Date"
            name="delegation_end"
            rules={[
              { required: true, message: 'Please select end date' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const startDate = getFieldValue('delegation_start');
                  if (!startDate || !value || value.isAfter(startDate)) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error('End date must be after start date')
                  );
                }
              })
            ]}
          >
            {isReadOnly ? (
              <Input
                readOnly
                value={
                  futureForm.getFieldValue('delegation_end')
                    ? moment(futureForm.getFieldValue('delegation_end')).format(
                        'YYYY-MM-DD'
                      )
                    : ''
                }
              />
            ) : (
              <DatePicker
                format="YYYY-MM-DD"
                suffixIcon={<CalendarOutlined />}
                style={{ width: '100%' }}
              />
            )}
          </FormItem>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <FormItem
            label="Assign From Approver"
            name="delegator_id"
            rules={[{ required: true }]}
          >
            {isReadOnly ? (
              <Input
                value={
                  user?.user_details?.role === 'user'
                    ? `${user?.user_details?.display_name} - (${user?.user_details?.email})`
                    : (() => {
                        const selected = approvers.find(
                          (a) =>
                            a.id === futureForm.getFieldValue('delegator_id')
                        );
                        return selected
                          ? `${selected.display_name} - (${selected.email})`
                          : '';
                      })()
                }
                readOnly
              />
            ) : user?.user_details.role === 'user' ? (
              <Select disabled value={user?.user_details?.id}>
                <Option value={user?.user_details?.id}>
                  {`${user?.user_details?.display_name} - (${user?.user_details?.email})`}
                </Option>
              </Select>
            ) : (
              <Select showSearch placeholder="Select approver">
                {approvers.map((approver) => (
                  <Option key={approver.id} value={approver.id}>
                    {`${approver.display_name} - (${approver.email})`}
                  </Option>
                ))}
              </Select>
            )}
          </FormItem>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <FormItem
            label="Assign To Approver"
            name="delegate_id"
            rules={[{ required: true }]}
          >
            {isReadOnly ? (
              // When read-only, show a read-only Input displaying the selected value
              <Input
                value={
                  user?.user_details?.role === 'user'
                    ? `${user.user_details.display_name} - (${user.user_details.email})`
                    : (() => {
                        const selected = approvers.find(
                          (a) =>
                            a.id === futureForm.getFieldValue('delegator_id')
                        );
                        return selected
                          ? `${selected.display_name} - (${selected.email})`
                          : '';
                      })()
                }
                readOnly
              />
            ) : user?.user_details?.role === 'user' ? (
              // If not readonly but user role is 'user', disable Select and show user's info
              <Select disabled value={user.user_details.id}>
                <Option value={user.user_details.id}>
                  {`${user.user_details.display_name} - (${user.user_details.email})`}
                </Option>
              </Select>
            ) : (
              // Else, normal Select with approvers list
              <Select showSearch placeholder="Select approver">
                {approvers.map((approver) => (
                  <Option key={approver.id} value={approver.id}>
                    {`${approver.display_name} - (${approver.email})`}
                  </Option>
                ))}
              </Select>
            )}
          </FormItem>
        </Col>
      </Row>
    </Form>
  );

  const renderStockTab = () => (
    <Form form={stockForm} layout="vertical">
      <FormItem name="env_ids" hidden>
        <Input />
      </FormItem>

      <Row>
        <Col span={24}>
          <FormItem
            label="Assign From Approver"
            name="delegator_id"
            rules={[{ required: true }]}
            readonly
          >
            {user?.user_details.role === 'user' ? (
              <Select disabled value={user?.user_details?.id}>
                <Option value={user?.user_details?.id}>
                  {user?.user_details?.display_name}
                </Option>
              </Select>
            ) : (
              <Select showSearch placeholder="Select approver">
                {approvers.map((approver) => (
                  <Option key={approver.id} value={approver.id}>
                    {`${approver.display_name} - (${approver.email})`}
                  </Option>
                ))}
              </Select>
            )}
          </FormItem>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <FormItem
            label="Assign To Approver"
            name="delegate_id"
            rules={[{ required: true }]}
          >
            {/* <Select showSearch placeholder="Select approver">
              {approvers.map((approver) => (
                <Option key={approver.id} value={approver.id}>
                  {`${approver.display_name} - (${approver.email})`}
                </Option>
              ))}
            </Select> */}
            {isReadOnly ? (
              // 🔒 Read-only: show Input with selected approver name/email
              <Input
                readOnly
                value={
                  user?.user_details?.role === 'user'
                    ? `${user.user_details.display_name} - (${user.user_details.email})`
                    : (() => {
                        const selected = approvers.find(
                          (a) =>
                            a.id === futureForm.getFieldValue('delegator_id')
                        );
                        return selected
                          ? `${selected.display_name} - (${selected.email})`
                          : '';
                      })()
                }
              />
            ) : user?.user_details?.role === 'user' ? (
              // 👤 User role: disabled Select showing only the user's info
              <Select disabled value={user.user_details.id}>
                <Option value={user.user_details.id}>
                  {`${user.user_details.display_name} - (${user.user_details.email})`}
                </Option>
              </Select>
            ) : (
              // ✍️ Editable mode for other roles
              <Select showSearch placeholder="Select approver">
                {approvers.map((approver) => (
                  <Option key={approver.id} value={approver.id}>
                    {`${approver.display_name} - (${approver.email})`}
                  </Option>
                ))}
              </Select>
            )}
          </FormItem>
        </Col>
      </Row>
      {selectedEnvelopes?.length > 0 && (
        <div className="envelope-section">
          <div className="envelope-header">
            <h4>Select Envelopes</h4>
            {/* <span className="selection-count">
            {selectedEnvelopes.length} of {envelopes.length} selected
          </span> */}
          </div>

          <Table
            dataSource={envelopes}
            // dataSource={
            //   isReadOnly
            //     ? envelopes.filter((e) => selectedEnvelopes.includes(e.id))
            //     : envelopes
            // }
            columns={envelopeColumns}
            pagination={false}
            size="small"
            className="envelope-table"
            rowClassName="envelope-row"
          />
        </div>
      )}
    </Form>
  );

  return (
    <CustomModal
      // footer={getFooterButtons()}
      onCancel={handleModalClose}
      visible={isViewModalVisible}
      title="View Delegation"
      footer={null}
      width={600}
      className="delegation-modal"
    >
      <Tabs
        activeKey={activeTab}
        onChange={handleTabChange}
        className="delegation-tabs"
      >
        <TabPane
          tab="Future"
          key="future"
          disabled={editDelegationDetails?.type === 'stock'}
        >
          {renderFutureTab()}
        </TabPane>
        <TabPane
          tab="Stock"
          key="stock"
          disabled={editDelegationDetails?.type === 'future'}
        >
          {renderStockTab()}
        </TabPane>
      </Tabs>
    </CustomModal>
  );
};

export default ViewDelegationModal;
